<template>

    <div class="notification-widget">
    </div>

</template>

<script>
export default {
    components: {},
    data() {
        return {
        };
    },
    props: [],
    computed: {
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
};
</script>        

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/NotificationWidget.vue